import moment from "moment";
import { S3_ENDPOINT, downloadFile } from "../utils";

const QuizCertificate = ({ test, type, attempt }) => {
  const renderCertificate = () => {
    const { certificate } = attempt;
    if (certificate && certificate !== null && test && test !== null) {
      const src = `${S3_ENDPOINT}/${certificate.name}.${certificate.type}`;
      const fileName = `Certificado-${test.course.name}.pdf`;
      return (
        <button
          onClick={() => downloadFile(src, fileName)}
          className="btn btn-primary shadow mt-4"
        >
          <i className="fa fa-download me-2"></i> Descargar{" "}
          {type && type !== null ? type : "Certificado"}
        </button>
      );
    }
    if (test?.course_id && test?.course_id !== null) {
      return (
        <p className="bold text-primary mt-4">
          Tu {type && type !== null ? type : "Certificado"} digital esta próximo
          a subirse.
        </p>
      );
    }
  };

  const renderTracking = () => {
    const { tracking_number } = attempt;
    if (tracking_number && tracking_number !== null) {
      return (
        <a
          href={tracking_number}
          rel="noreferrer"
          target="_blank"
          className="btn mt-4 btn-link"
        >
          <i className="fa fa-truck me-2"></i> Rastrear Envío de{" "}
          {type && type !== null ? type : "Certificado"} Físico
        </a>
      );
    }
    if (test?.course_id && test?.course_id !== null) {
      return (
        <p className="bold text-primary mt-4">
          Tu {type && type !== null ? type : "Certificado"} físico esta próximo
          a enviarse.
        </p>
      );
    }
  };
  return (
    <div className="row">
      <div className="col-12 col-md-6 text-right">{renderCertificate()}</div>
      <div className="col-12 col-md-6 text-left">{renderTracking()}</div>
      <div className="col-12">
        <div className="text-center mt-4">
          <p>
            Estamos trabajando en tu certificado digital y en la guía de envío,
            los cuales recibirás dentro de los próximos 15 días hábiles.
          </p>
          <p>
            Tu certificado físico puede tomar un poco más de tiempo, ya que
            primero debe pasar por un proceso de preparación y logística antes
            de ser entregado a la paquetería.
          </p>
          <p>Agradecemos mucho tu paciencia y comprensión.</p>
        </div>
      </div>
      {attempt.tracking_number && attempt.tracking_number === null && (
        <p className="text-center mt-4">
          Tiempo estimado de entrega de{" "}
          {type && type !== null ? type : "certificado"} físico:{" "}
          <span className="bold">15 días hábiles</span> contando a partir del{" "}
          <span className="bold">
            {moment(attempt.gradedAt).format("DD MMM YYYY")}
          </span>
        </p>
      )}
    </div>
  );
};

export default QuizCertificate;
